import React from 'react';
import PropTypes from 'prop-types';

/**
 * Avatar button for the CDS Pasajero Frecuente user menu.
 * @param {object} props
 * @param {string} props.avatar
 * @param {string} props.label
 * @param {string} [props.displayText]
 * @param {boolean} props.isAuthenticated
 * @param {boolean} [props.isMenuOpen]
 * @param {Function} props.onClick
 * @returns {React.ReactElement}
 */
function CdsFpUserMenuButton({ avatar, label, displayText, isAuthenticated, isMenuOpen, onClick }) {
  return (
    <button
      type="button"
      className="flex w-fit cursor-pointer items-center rounded-full"
      onClick={onClick}
      aria-label={label}
      aria-expanded={isAuthenticated ? isMenuOpen : undefined}
      aria-haspopup={isAuthenticated ? 'menu' : undefined}
    >
      <div className="flex items-center justify-center rounded-full bg-white/10 md:pr-1">
        <div className="relative h-10 w-10 rounded-full overflow-hidden bg-primary-regular flex items-center justify-center">
          <img src={avatar} alt="" className="h-full w-full rounded-full object-cover p-1" />
        </div>
        {displayText && (
          <span className="text-xs hidden px-2 text-white md:block">{displayText}</span>
        )}
      </div>
    </button>
  );
}

CdsFpUserMenuButton.propTypes = {
  avatar: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  displayText: PropTypes.string,
  isAuthenticated: PropTypes.bool.isRequired,
  isMenuOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

CdsFpUserMenuButton.defaultProps = {
  displayText: '',
  isMenuOpen: false,
};

export default CdsFpUserMenuButton;
